import axiosInstance from "auth/FetchInterceptor";
import {
  HANDLE_WARNING, HANDLE_WARNING_MARK_RESOLVED,
  HANDLE_WARNING_PINNED,
  HANDLE_WARNING_PROCESSING,
  SEARCH_WARNING_DETAIL,
  WARNING_SEARCH_GRID
} from "constants/ApiConstant";
const WarningService = {};

WarningService.warningSearchApi = function (data) {
  return axiosInstance.post(WARNING_SEARCH_GRID, data);
};

WarningService.handleWarning = function (data) {
  return axiosInstance.post(HANDLE_WARNING, data);
};

WarningService.getWarningDetail = function (id) {
  return axiosInstance.get(`${SEARCH_WARNING_DETAIL}/${id}`, null);
};
WarningService.pinnedWarning = function (data) {
  return axiosInstance.put(HANDLE_WARNING_PINNED, data);
};
WarningService.processingWarning = function (data) {
  return axiosInstance.post(HANDLE_WARNING_PROCESSING, data);
};

export default WarningService;
